import { useEffect } from 'react';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';
import WorkingHours from './components/WorkingHours';

export default function ContactPage() {
  useEffect(() => {
    // Inject Schema.org JSON-LD for ContactPage
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yanginalgila.com';
    
    const schemaContactPage = {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "İletişim - YANGINALGILA.COM",
      "url": `${siteUrl}/iletisim`,
      "description": "Yangın algılama sistemleri hakkında bilgi almak ve teklif için bizimle iletişime geçin.",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "YANGINALGILA.COM",
        "image": `${siteUrl}/og-image.jpg`,
        "url": siteUrl,
        "telephone": "+90-312-XXX-XXXX",
        "email": "info@yanginalgila.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Ankara",
          "addressLocality": "Ankara",
          "addressRegion": "Ankara",
          "postalCode": "06000",
          "addressCountry": "TR"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 39.925533,
          "longitude": 32.866287
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+90-312-XXX-XXXX",
          "contactType": "customer service",
          "email": "info@yanginalgila.com",
          "availableLanguage": "Turkish",
          "areaServed": "TR"
        }
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaContactPage);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main className="min-h-screen">
      <h1 className="sr-only">İletişim - YANGINALGILA.COM</h1>
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <MapSection />
      <WorkingHours />
    </main>
  );
}
